
export const validateEmail = (email) => {
    if (email === null || email === "") return "O email é um campo obrigatório";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return "O email não é válido";
    return null;
}

export const validatePassword = (password) => {
    if (password === null || password === "") return "A password é um campo obrigatório";
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?_&])[A-Za-z\d@$!%*?_&]{8,}$/;
    if (password.length < 8) return "A password tem de ter no mínimo 8 caracteres";
    if (!passwordRegex.test(password)) return "A password tem de conter uma letra maiúscula, uma letra minúscula, um número e um destes caracteres especiais @$!%*?_&";
    return null;
}
